/* eslint-disable camelcase */
import React, { useEffect, useState } from 'react';

// Sagas
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import 'react-image-lightbox/style.css';
import { withTranslation } from 'react-i18next';

import toastr from 'toastr';
import 'toastr/build/toastr.min.css';

import ReactApexChart from 'react-apexcharts';

import { get } from '../../helpers/api_helper';
import { buildHorizontalBarOptions, dashboardPalette } from './chartTheme';

function TVProductivityChart(props) {
  const { t, date } = props;

  toastr.options = {
    positionClass: 'toast-top-right',
    newestOnTop: true,
  };

  const [data, setData] = useState(null);
  const [chartOptions, setChartOptions] = useState(null);
  const [chartSeries, setChartSeries] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await get(`/api/tvs/reports/inducted?isoDay=${date}`);
        setData(response);
      } catch (error) {
        toastr.error(t('Error fetching TV productivity data'));
      }
    };

    fetchData();
  }, [date]);

  useEffect(() => {
    if (data) {
      setChartOptions(buildHorizontalBarOptions({
        categories: data.map((item) => item.inducted_by),
        xTitle: 'Inductions',
        tooltipFormatter: (val) => `${val} tvs`,
        color: dashboardPalette.secondary,
        barHeight: '48%',
        height: 260,
      }));

      setChartSeries([
        {
          name: 'Inducted TVs',
          data: data.map((item) => item.tvs),
        },
      ]);
    }
  }, [data]);

  return (
    <div className="dashboard-chart dashboard-chart--compact">
      {chartOptions && chartSeries && (
        <ReactApexChart options={chartOptions} series={chartSeries} type="bar" height={260} />
      )}
      {chartOptions === null && (
        <div className="text-center">
          <span className="mdi mdi-loading mdi-spin fs-2" />
        </div>
      )}
    </div>
  );
}

TVProductivityChart.propTypes = {
  // eslint-disable-next-line react/require-default-props
  t: PropTypes.any,
  date: PropTypes.string.isRequired,
};

export default connect(() => ({

}), {})(withTranslation()(TVProductivityChart));
